import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    color: "#193446",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M12.885 3h2.068l-4.527 5.084L15.75 15h-4.162l-3.27-4.195L4.588 15H2.52l4.838-5.43L2.25 3.014h4.27L9.466 6.85l3.42-3.837zm-.73 10.779h1.15L5.898 4.155h-1.23z" fill="currentColor"/>' }
  })
);